import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

// components
import { Text } from './..'

// Styles
import styles from './NavigationButton.module.scss'

const NavigationButton = React.forwardRef(
  ({ className, children, onClick, ...restProps }, ref) => {
    return (
      <button
        className={classnames(styles.button, className)}
        ref={ref}
        onClick={onClick}
        {...restProps}
      >
        <Text
          weight='semibold'
          element='span'
          color='blue'
          className={classnames(styles.buttonChild)}
        >
          {children}
        </Text>
      </button>
    )
  }
)

NavigationButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.node,
  ]),
  onClick: PropTypes.func,
}

export default NavigationButton
